module.exports = __webpack_public_path__ + "img/Editor.3354415a.png";